import {connect} from "react-redux";
import CompleteDealerLeadActivity from "./Complete";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../../service/fileUpload/action";
import {
    markAttendancesDealerLead,
    getActivityDealerLead,
    userCheckoutDealerLead,
    activityTypes,
    newActivityDealerLead,
    getSenior,
    addTaggedAlong,
} from "../../../../../service/Dealer/action";
import {getLeadById} from "../../../../../service/Lead/action";
import {errorLogs} from "../../../../../service/FasttagToll/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    markAttendanceDetails: state.Dealer.markAttendance,
    getActivityDetails: state.Dealer.getActivity,
    isCheckoutDetails: state.Dealer.isCheckoutDetails,
    activityTypesDetails: state.Dealer.activityTypesDetails,
    NewActivityDetails: state.Dealer.saveNewActivity,
    dealerByIdDetails: state.Dealer.dealerById,
    senior: state.Dealer.senior,
    addedTaggedAlong: state.Dealer.addedTaggedAlong,
    leadById:state.Lead.leadById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            markAttendancesDealerLead,
            getActivityDealerLead,
            newActivityDealerLead,
            userCheckoutDealerLead,
            activityTypes,
            getSenior,
            addTaggedAlong,
            getLeadById,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CompleteDealerLeadActivity);
